import i18next from 'i18next';

i18next.addResources('es', 'breadcrumb', { label: 'Ruta de navegación' });
i18next.addResources('en', 'breadcrumb', { label: 'Breadcrumb' });
i18next.addResources('pt', 'breadcrumb', { label: 'Trilha de navegação' });
